import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";

export default [
    { name: "Header", component: Header },
    { name: "Footer", component: Footer },
];